<div [@fadeInOutHidden]='!disabled'>
  <div class="d-flex flex-column">

    <label [@fadeInOutHidden]='questionText'
      [for]="idText">
      {{questionText}}
    </label>
    <div class="input-container">
      <div class="dropdown-container"
        data-elem="dropdown"
        [ngClass]="{'data-hj-suppress': addHotJarSuppressionTag}">
        <div class="select-wrapper" data-elem="dropdown" (click)="triggerGtmEvent(gtmEventIds.expiryYear, 'purchaseMonth')" tabIndex="0">
          <div class="select-input-section" data-elem="dropdown">
            <input [id]="idText"
              [(ngModel)]="selectedMonth"
              data-elem="dropdown"
              placeholder="Month"
              [ngModelOptions]="{standalone: true}"
              readonly>
            </div>
            <div class="select-dropdown-icon"
            data-elem="dropdown"></div>
          </div>
          @if (monthsList.length>0) {
            <div class="option-menu-wrapper">
              @for (option of monthsList; track option) {
                <div class="option-section"
                  (click)="optionSelected(true, option)">
                  {{option.value}}
                </div>
              }
            </div>
          }
        </div>


        <div class="dropdown-container"
          data-elem="dropdown"
          [ngClass]="{'data-hj-suppress': addHotJarSuppressionTag}">
          <div class="select-wrapper" data-elem="dropdown" (click)="triggerGtmEvent(gtmEventIds.expiryYear, 'purchaseMonth')" tabIndex="0">
            <div class="select-input-section" data-elem="dropdown">
              <input [id]="idText"
                [(ngModel)]="selectedYear"
                data-elem="dropdown"
                placeholder="Year"
                [ngModelOptions]="{standalone: true}"
                readonly>
              </div>
              <div class="select-dropdown-icon"
              data-elem="dropdown"></div>
            </div>
            @if (yearsList.length>0) {
              <div class="option-menu-wrapper">
                @for (option of yearsList; track option) {
                  <div class="option-section"
                    (click)="optionSelected(false, option)">
                    {{option.value}}
                  </div>
                }
              </div>
            }
          </div>
        </div>

        @if (shouldShowError()) {
          <div
            [@fadeInOut] class="error-section">
            <div class="error-msg-icon"></div>
            <p class="error-text">
              {{getErrorMessage()}}
            </p>
          </div>
        }

      </div>
    </div>